<template>
	<div style="width:800px; height:600px;">
		<div class="list_top_box" v-if="displaySearchCondition">
			<div class="left_option">
				<em class="lt_text">Dept.</em>
				<span class="int_type_no_border mgr_5"> <CodeSelect :width="70" :descWidth="100" :codes="depts" v-model="dept_code" @set-code="setDepartment" @post-loading="postDeptsLoading" /> </span>
				<!-- <em class="lt_text">{{ dept_name }}</em> -->

				<em class="lt_text ">S. Team</em>
				<span class="int_type_no_border mgr_5">
					<CodeSelect :descWidth="100" :codes="salesteams" :excludeCode="excludeTeamCode" :displayDescription="true" v-model="salesteam_code" @set-code="setSalesteam" />
				</span>
				<!-- <em class="lt_text">{{ salesteam_name }}</em> -->

				<span class="int_type mgr_5">
					<input type="text" style="width:120px;" v-model="keyword" placeholder="Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
		<div class="view_inner">
			<div class="fixed-table-container" style="height:470px;">
				<div class="table-wrapper">
					<table id="item_list" class="list_tbl">
						<thead>
							<tr>
								<th style="text-align:center;width:3%;">
									<div class="th-text"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></div>
								</th>
								<th style="text-align:center;width:12%;"><div class="th-text">User ID</div></th>
								<th style="text-align:center;width:20%;"><div class="th-text">Name</div></th>
								<th style="text-align:center;width:20%"><div class="th-text">Team Name</div></th>
								<th style="text-align:center;width:30%;"><div class="th-text">Team Description</div></th>
								<th style="text-align:center;width:15%;"><div class="th-text">Telephone</div></th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="user in users" v-bind:key="user.user_id" @click="selectRow(user)">
								<td style="text-align:center"><input type="checkbox" v-model="selectedUserIds" :value="user.user_id" /></td>
								<td>{{ user.user_id }}</td>
								<td>{{ user.name }}</td>
								<td>{{ user.sales_team_name }}</td>
								<td>{{ user.sales_team_description }}</td>
								<td>{{ user.phone_no }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- <div>
					{{ selectedUserIds }}
				</div> -->
			</div>

			<br />

			<div class="view_bottom_bt">
				<a href="javascript:;" id="save" type="button" class="search_bt" @click="submit()">Save & Close</a>
				<a href="javascript:;" id="save" type="button" class="gray_bt" @click="close()">Cancel</a>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import '@/assets/css/table_box.css';
// import _ from 'lodash';
import { apiIndex, apiSelectUserList } from '@/api/basicinfo/user.js';
import { apiSelectCodeList } from '@/api/basicinfo/code';
import CodeSelect from '@/components/common/CodeSelect';
//import { apiIndex, apiUpdateItem } from '@/api/item/master.js';
// import CodeSelect from '@/components/common/CodeSelect';

export default {
	data: function() {
		return {
			// units: [],
			// locations: [],
			// item: {},

			users: [],

			dept_code: '',
			dept_name: '',
			depts: [],

			salesteam_code: '',
			salesteam_name: '',
			salesteams: [],

			keyword: null,

			allSelected: false,

			selectedUserIds: [],
		};
	},
	props: {
		excludeTeamCode: {
			type: String,
			default: '',
		},
		initialDeptCode: {
			type: String,
			default: null,
		},
		displaySearchCondition: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		// filteredUsers() {
		// 	var vm = this;
		// 	//return this.users.filter(u => u.salesteam_code != vm.excludeTeamCode);
		// 	return this.users.filter(u => u.salesteam_code == vm.excludeTeamCode);
		// },
		// sessionUser: function() {
		// 	return this.$session.get('user');
		// },
	},
	components: {
		CodeSelect,
	},
	methods: {
		postDeptsLoading() {
			//this.status_code = this.initialStatusCode;
			// console.log('post loading', this.status_code);
			// this.$forceUpdate();
			if (this.initialDeptCode) {
				this.dept_code = this.initialDeptCode;
				//if (this.initialShipToCode) {
				//console.log(this.initialShipToCode);
				this.$nextTick(() => {
					this.search();
				});
			}
		},
		// test(user) {
		// 	// console.log('ㅠㅠ');
		// 	// user.selected = !user.selected;
		// 	// this.t = user.selected;
		// 	// console.log(user.selected);
		// 	// this.allSelected = !this.allSelected;
		// 	// this.selectAll();
		// 	//console.log('Hmmmmm', t);
		// },
		// errorToastAndReturn(msg) {
		// 	this.$toast.error(msg);
		// 	return false;
		// },
		// isValid() {
		// 	if (this.session_user.admin_yn == 'N' && !this.old_password) return this.errorToastAndReturn('Old password is empty');
		// 	if (!this.new_password || !this.new_password_confirm) return this.errorToastAndReturn('New password is empty');
		// 	if (this.new_password != this.new_password_confirm) return this.errorToastAndReturn('New passwords are different');
		// 	return true;
		// },
		async submit() {
			if (this.selectedUserIds.length > 0) {
				//this.$toast.success('Saved successfully');
				this.$emit('set-users', this.selectedUserIds);
				this.close();
			} else {
				this.$toast.error('No user selected');
			}
		},
		selectAll() {
			var vm = this;

			vm.selectedUserIds = [];
			if (vm.allSelected) {
				this.users.forEach(function(user) {
					vm.selectedUserIds.push(user.user_id);
				});
			}
		},
		reset() {
			this.keyword = null;
			this.dept_code = null;
			this.salesteam_code = null;

			this.selectUsers();
			//this.active_yn = 'Y';
		},
		search() {
			this.selectUsers();
		},
		selectRow(user) {
			if (this.selectedUserIds.includes(user.user_id)) {
				const index = this.selectedUserIds.indexOf(user.user_id);
				if (index > -1) {
					this.selectedUserIds.splice(index, 1);
				}
			} else this.selectedUserIds.push(user.user_id);
		},
		async selectUsers() {
			this.allSelected = false;
			this.selectedUserIds = [];

			const { data } = await apiSelectUserList({
				dept_code: this.dept_code,
				salesteam_code: this.salesteam_code,
				exclude_salesteam_code: this.excludeTeamCode,
				keyword: this.keyword,
				paging_yn: 'N',
				active_yn: 'Y',
			});
			// this.pensioners = data;
			// if (this.pensioners.length > 0 && this.selectedPsNo == null) {
			// 	this.selectRow(this.pensioners[0]);
			// }
			//console.log(data);
			this.users = data.userList;
			// this.users.forEach(function(user) {
			// 	user.selected = false;
			// });
		},
		setDepartment(code) {
			//console.log(code);
			if (code) this.dept_name = code.name;
			else this.dept_name = '';
			this.selectUsers();
		},
		setSalesteam(code) {
			//console.log(code);
			if (code) this.salesteam_name = code.name + ' (' + code.description + ')';
			else this.salesteam_name = '';
			this.selectUsers();
		},
		async index() {
			var response = await apiIndex();
			this.depts = response.data.deptList;

			response = await apiSelectCodeList({
				code_type: 'ST',
				active_yn: 'Y',
			});
			this.salesteams = response.data.codeList;
		},
		close() {
			this.$emit('close');
		},
		async init() {
			if (this.initialDeptCode) {
				this.$nextTick(() => {
					this.dept_code = this.initialDeptCode;
				});
			}
			await this.index();
			await this.selectUsers();
		},
	},
	created() {
		// this.index();
		// this.selectUsers();
		this.init();
		//this.item = _.cloneDeep(this.selectedItem);
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
